var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-fab-transition',[_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],attrs:{"color":"black","dark":"","fixed":"","bottom":"","right":"","fab":""},on:{"click":_vm.scrollToTop}},[_c('v-icon',[_vm._v("mdi-chevron-double-up")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }